import { ITranslationsCollection } from '@estee/elc-service';
import { InventoryStatus } from '../../internal/constants/InventoryStatuses';
import { IMapping } from '../interfaces/IProductCTA';

export const buttonLabels = (
    translations: ITranslationsCollection,
    customActiveLabel?: string,
    customPromoLabel?: string
): IMapping => {
    const {
        addToBagButtonLabel,
        comingSoonButtonLabel,
        outOfStockButtonLabel,
        preOrder,
        soldOutButtonLabel,
        pressedCtaButtonLabel
    } = translations as ITranslationsCollection;

    return {
        [InventoryStatus.Active]: customActiveLabel || addToBagButtonLabel,
        [InventoryStatus.ComingSoon]: comingSoonButtonLabel,
        [InventoryStatus.FreePromo]: customPromoLabel || addToBagButtonLabel,
        [InventoryStatus.PreOrder]: preOrder,
        [InventoryStatus.SoldOut]: soldOutButtonLabel,
        [InventoryStatus.TempOutOfStock]: outOfStockButtonLabel,
        [InventoryStatus.OnBag]: pressedCtaButtonLabel
    };
};
